import React, { useState } from "react";

export default function Nofound() {
  const [user, setUser] = useState();
  
  return (
    <div className="error-page">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6">
            <div className="error-card text-center p-5">
              <div className="error-icon mb-4">
                <span className="display-1 fw-bold">404</span>
                <i className="bi bi-exclamation-circle position-absolute text-warning"></i>
              </div>
              
              {user?.user && <h2 className="mb-3">Hello, {user.user}</h2>}
              
              <h3 className="mb-3">Page Not Found</h3>
              <p className="text-muted mb-4">
                Oops! The page you are looking for doesn't exist or has been moved.
              </p>
              
              <div className="d-grid gap-3">
                <a href="/" className="btn btn-primary btn-lg">
                  Return to Homepage
                </a>
                <a href="/contact" className="btn btn-outline-light">
                  Contact Support
                </a>
              </div>
            </div>
            
            <p className="text-center text-muted mt-4">
              © {new Date().getFullYear()} Your Company Name
            </p>
          </div>
        </div>
      </div>
      
      <style jsx>{`
        .error-page {
          background: linear-gradient(145deg, #6a11cb, #2575fc);
          min-height: 100vh;
          display: flex;
          align-items: center;
          font-family: 'Nunito', sans-serif;
          padding: 2rem 1rem;
        }
        
        .error-card {
          background-color: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
          border-radius: 1rem;
          box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
          border: 1px solid rgba(255, 255, 255, 0.2);
          color: white;
          position: relative;
          overflow: hidden;
        }
        
        .error-card::before {
          content: '';
          position: absolute;
          top: -50px;
          right: -50px;
          width: 100px;
          height: 100px;
          border-radius: 50%;
          background-color: rgba(255, 255, 255, 0.1);
          z-index: 0;
        }
        
        .error-icon {
          position: relative;
        }
        
        .error-icon i {
          font-size: 2rem;
          top: 0;
          right: 25%;
        }
        
        .btn-primary {
          background-color: white;
          color: #6a11cb;
          border: none;
          transition: all 0.3s ease;
        }
        
        .btn-primary:hover {
          background-color: #f8f9fa;
          color: #2575fc;
          transform: translateY(-3px);
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
        }
        
        .btn-outline-light {
          border-color: rgba(255, 255, 255, 0.3);
          transition: all 0.3s ease;
        }
        
        .btn-outline-light:hover {
          background-color: rgba(255, 255, 255, 0.1);
          transform: translateY(-3px);
        }
      `}</style>
    </div>
  );
}